import { render, staticRenderFns } from "./pdf-viewer-host.vue?vue&type=template&id=76c8429a"
import script from "./pdf-viewer-host.vue?vue&type=script&lang=js"
export * from "./pdf-viewer-host.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports